import colors from '../constants/colors';
import styled from 'styled-components';

export const SelectLayout = styled.div`
  position: relative;
`;

export const selectStyles = error => ({
  container: provided => ({
    ...provided,
    fontSize: '16px',
    lineHeight: 1.5,
    fontWeight: 450,
  }),
  control: (provided, { isFocused, isDisabled, readOnly }) => ({
    ...provided,
    boxSizing: 'border-box',
    background: colors.ghostWhite,
    borderRadius: '8px',
    outline: 'none',
    padding: '4px',
    color: isDisabled || readOnly ? colors.lunarRays : colors.slateGrey,
    boxShadow: 'none',
    borderWidth: '1.5px',
    borderColor:
      (error && colors.opalFlame) ||
      (isFocused && !error && colors.tulleGrey) ||
      (isDisabled && !error && colors.athensGrey) ||
      colors.littleDipper,
    '&:hover': {
      borderColor: !error && !isDisabled && !readOnly && colors.tulleGrey,
    },
    height: '60px',
  }),
  menu: provided => ({
    ...provided,
    background: colors.ghostWhite,
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${colors.littleDipper}`,
    lineHeight: 1.5,
    marginTop: '8px',
    marginBottom: '16px',
    zIndex: 2,
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    backgroundColor: isSelected && colors.ghostWhite,
    color: colors.slateGrey,
    '&:hover': {
      backgroundColor: colors.littleDipper,
    },
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  placeholder: (provided, { isDisabled }) => ({
    ...provided,
    color: isDisabled ? colors.littleDipper : colors.lunarRays,
    fontSize: '16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  singleValue: (provided, { isDisabled }) => ({
    ...provided,
    color: (error && colors.opalFlame) || (isDisabled && colors.lunarRays) || colors.slateGrey,
  }),
});

export default selectStyles;
